// ActivityTracker — mounts the active-work log for any signed-in session (docs/ACTIVITY_HUD_PLAN.md).
// Renders nothing. Mounted once in App.jsx inside <SignedIn>, so it never runs for a signed-out
// client on a public token page.
//
// Also finishes the Google Calendar connection: Google sends the person back to /?gcal=connected
// (or ?gcal=error&msg=…). We say how it went and reopen their time card, where the result shows.
import { useEffect } from 'react'
import { useAuth } from '@clerk/clerk-react'
import { startActivityTracking } from '../services/activity.js'
import { alertDialog } from './Dialog.jsx'

export default function ActivityTracker() {
  const { getToken } = useAuth()
  useEffect(() => { startActivityTracking(() => getToken()) }, [getToken])

  useEffect(() => {
    const url = new URL(window.location.href)
    const g = url.searchParams.get('gcal')
    if (!g) return
    const msg = url.searchParams.get('msg') || ''
    const kind = url.searchParams.get('kind') || ''
    url.searchParams.delete('gcal'); url.searchParams.delete('msg'); url.searchParams.delete('kind')
    window.history.replaceState(null, '', url.pathname + (url.search || '') + url.hash)
    // Give the outline (and its dialog host) a moment to mount.
    setTimeout(async () => {
      if (g === 'connected' && kind === 'mail') {
        await alertDialog({ title: 'Email connected', message: 'Email you send on projects will now appear in the suggestions on your time card (who it went to and the subject, never the message itself).' })
        window.dispatchEvent(new CustomEvent('open-timecard'))
      } else if (g === 'connected') {
        await alertDialog({ title: 'Calendar connected', message: 'Your meetings will now appear as suggestions on your time card.' })
        window.dispatchEvent(new CustomEvent('open-timecard'))
      } else {
        await alertDialog({ title: 'Calendar not connected', message: msg || 'Google did not finish the connection. Try again from your time card.' })
      }
    }, 1500)
  }, [])

  return null
}
